module.exports = __webpack_public_path__ + "img/hydrologiskpalegg.e3a86d2d.jpg";